import { Certificate, Certificates, InputEnumOption, IssuedCertificate, Translations } from "@salaxy/core";

import { CertificateService, UiHelpers } from "../../services";
import { CrudControllerBase } from "../bases/CrudControllerBase";

/** Certificate controller for listing certificate, revoking and requesting a new certificate. */
export class CertificateController extends CrudControllerBase<Certificate> {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["CertificateService", "$location", "$attrs", "UiHelpers", "Certificates"];

  constructor(
    private certificateService: CertificateService,
    $location: angular.ILocationService,
    $attrs: angular.IAttributes,
    uiHelpers: UiHelpers,
    private certificateApi: Certificates,
  ) {
    super(certificateService, $location, $attrs, uiHelpers);
  }

  /** Creates a new certificate */
  public createNew(): Certificate {
    super.createNew();
    this.current.title = Translations.get("SALAXY.NG1.CertificatesComponent.newCertificate");
    return this.current;
  }

  public result: {
    /** Certificate file as blob. */
    blob: Blob;
    /** Certificate file as text. */
    text: string;
    /** Certificate thumbprint. */
    thumbprint: string;
  } = undefined;

  /** Certificate format (id) */
  public certFormat: "pfx" | "pem" = "pfx";

  /** Returns the metadata for the certFrmat */
  public get currentCertFormat() {
    return this.certFormats.find((f) => f.value === this.certFormat) || this.certFormats[0];
  }

  /** Avilabe certificate formats */
  public certFormats: InputEnumOption[] = [
    {
      value: "pfx",
      text: "Windows-sertifikaatti (pfx / pkcs12)",
      ui: {
        mime: "application/x-pkcs12",
        suffix: "pfx",
      }
    }, {
      value: "pem",
      text: "Yleinen sertifikaatti (zip / pem)",
      ui: {
        mime: "application/zip",
        suffix: "zip",
      },
    },
  ];

  /**
   * Shows a dialog for adding nw certificate.
   */
  public showCertificateAddDialog() {
    this.createNew();
    this.uiHelpers.showDialog("salaxy-components/modals/account/CertificateAdd.html", "CertificateController");
  }

  /** Creates a new certificate */
  public createCert(): void {
    const loading = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    if (this.certFormat === "pem") {
      this.certificateApi.issuePemCertificate(this.current).then((certificate: IssuedCertificate) => {
        this.result = {
          blob: this.uiHelpers.bytes2Blob(certificate.bytes, this.currentCertFormat.ui.mime),
          text: certificate.cert + "\n\n" + certificate.key,
          thumbprint: certificate.thumbprint,
        };
        loading.dismiss();
      });
    } else {
      super.saveCurrent().then((certificate: Certificate) => {
        this.result = {
          blob: this.uiHelpers.bytes2Blob(certificate.bytes, this.currentCertFormat.ui.mime),
          text: certificate.bytes,
          thumbprint: certificate.thumbprint,
        };
        loading.dismiss();
      });
    }
  }

  /**
   * Downloads current.blob as pfx and sets current.id as name
   */
  public downloadCertFile() {
    this.uiHelpers.downloadFile(this.result.blob, `${this.result.thumbprint}.${this.currentCertFormat.ui.suffix}`);
  }
}
